import api from './api';

export interface AuditLogEntry {
  _id: string;
  actor?: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
  };
  actorEmail?: string;
  actorRole?: string;
  action: string;
  resourceType: string;
  resourceId?: string;
  resourceLabel?: string;
  ip?: string;
  createdAt: string;
  metadata?: Record<string, any>;
}

export const auditService = {
  async getLogs(params?: { page?: number; limit?: number; action?: string; search?: string }) {
    const query = new URLSearchParams();
    if (params?.page) query.append('page', String(params.page));
    if (params?.limit) query.append('limit', String(params.limit));
    if (params?.action) query.append('action', params.action);
    if (params?.search) query.append('search', params.search);

    const response = await api.get(`/audit-logs?${query.toString()}`);
    return response.data as {
      success: boolean;
      data: AuditLogEntry[];
      pagination: { page: number; limit: number; total: number; pages: number };
    };
  }
};
